export function mapDealRedemptionCtaLinkInfo(input: string) {
    // Check if input is a JSON string
    if (input && input.trim().startsWith('{')) {
        try {
            // Parse the JSON string
            const parsed = JSON.parse(input);
            // Extract the desired fields
            const { name, href, link_text, aria_label, link_type } = parsed;
            // Return an object with the extracted fields
            return { name, href, link_text, aria_label, link_type };
        } catch (error) {
            console.error('Error parsing JSON:', error);
            return null;
        }
    } else {
        console.warn('Input is not a valid JSON string.');
        return null;
    }
}
